import { render, staticRenderFns } from "./PlayerConversationLeft.vue?vue&type=template&id=552179c9&scoped=true&"
import script from "./PlayerConversationLeft.vue?vue&type=script&lang=js&"
export * from "./PlayerConversationLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552179c9",
  null
  
)

export default component.exports